import React from 'react';
import { Navigation as PolarisNavigation, Icon, Text, Badge, LegacyStack } from '@shopify/polaris';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
  HomeMajor,
  ProductsMajor,
  StoreMajor,
  SettingsMajor,
  AutomationMajor,
  LogOutMinor,
  CustomersMajor,
  CreditCardMajor,
  ReceiptMajor,
  NoteMajor,
  ListMajor
} from '@shopify/polaris-icons';
import { version } from '../utils/version';

export default function Navigation() {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout, user, isAdmin } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const navigationItems = [
    {
      url: '/app',
      label: 'Dashboard',
      icon: HomeMajor,
      selected: location.pathname === '/app' || location.pathname === '/app/',
      onClick: () => navigate('/app')
    },
    {
      url: '/app/products',
      label: 'Products',
      icon: ProductsMajor,
      selected: location.pathname === '/app/products',
      onClick: () => navigate('/app/products')
    },
    {
      url: '/app/shops',
      label: 'Shops',
      icon: StoreMajor,
      selected: location.pathname === '/app/shops',
      onClick: () => navigate('/app/shops')
    },
    {
      url: '/app/sizecharts',
      label: 'Sizechart Manager',
      icon: ListMajor,
      selected: location.pathname.startsWith('/app/sizecharts'),
      onClick: () => navigate('/app/sizecharts')
    },
    {
      url: '/app/name-pools',
      label: 'Name Pools',
      icon: NoteMajor,
      selected: location.pathname.startsWith('/app/name-pools'),
      onClick: () => navigate('/app/name-pools')
    },
    {
      url: '/app/subscription',
      label: 'Subscription',
      icon: CreditCardMajor,
      selected: location.pathname === '/app/subscription',
      onClick: () => navigate('/app/subscription')
    },
    {
      url: '/app/credits',
      label: 'Flex Credits',
      icon: CreditCardMajor,
      selected: location.pathname === '/app/credits',
      onClick: () => navigate('/app/credits')
    },
    {
      url: '/app/payment-history',
      label: 'Payment History',
      icon: ReceiptMajor,
      selected: location.pathname === '/app/payment-history',
      onClick: () => navigate('/app/payment-history')
    },
    {
      url: '/app/settings',
      label: 'Settings',
      icon: SettingsMajor,
      selected: location.pathname === '/app/settings',
      onClick: () => navigate('/app/settings')
    },
    {
      label: 'Logout',
      icon: LogOutMinor,
      onClick: handleLogout
    }
  ];

  if (isAdmin) {
    navigationItems.splice(navigationItems.length - 1, 0, {
      url: '/app/admin',
      label: 'Admin Panel',
      icon: CustomersMajor,
      selected: location.pathname === '/app/admin',
      onClick: () => navigate('/app/admin')
    });
  }

  navigationItems.push({
    url: '/app/changelog',
    label: 'Changelog',
    icon: NoteMajor,
    selected: location.pathname === '/app/changelog',
    onClick: () => navigate('/app/changelog'),
    badge: version
  });

  return (
    <PolarisNavigation location="/">
      <PolarisNavigation.Section items={navigationItems} />
    </PolarisNavigation>
  );
}
